import React from 'react'
import Shop from '@components/shop'
import MainLayout from '@layouts/main-layout'

const ShopPage = () => {
  return (
    <>
      <Shop />
    </>
  )
}

ShopPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default ShopPage
